import { render, staticRenderFns } from "./StartupCostsList.vue?vue&type=template&id=0cb7da4c"
import script from "./StartupCostsList.vue?vue&type=script&lang=js"
export * from "./StartupCostsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports